import {createAsyncThunk} from '@reduxjs/toolkit';
import {handleApiError} from 'common/src/modules/errorHandling/handleApiError';
import dashboardsApi from 'common/src/modules/dashboards/dashboards.api';
import {updateWidgets} from '../insightsPage.slice';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';

export const refreshWidgets = createAsyncThunk<void, {dashboardId: number}>(
  `${BreadcrumbName.CampaignInsights}/refreshWidgets`,
  async ({dashboardId}, {dispatch}) => {
    try {
      const widgets = await dashboardsApi.getWidgets(dashboardId);

      dispatch(updateWidgets(widgets));
    } catch (error) {
      handleApiError(error);
    }
  },
);
